/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricerange1Inputs */

const en_pricerange1 = /** @type {(inputs: Pricerange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

const de_pricerange1 = /** @type {(inputs: Pricerange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisspanne`)
};

/**
* | output |
* | --- |
* | "Price Range" |
*
* @param {Pricerange1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pricerange1 = /** @type {((inputs?: Pricerange1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricerange1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricerange1(inputs)
	return de_pricerange1(inputs)
});
export { pricerange1 as "priceRange" }